export default __webpack_public_path__ + "static/media/p2.06e4f288.png";